import { BRANDS } from '../components/Itv/types';

const GAME_DETAILS_BASE = '/game-details';
const ITV_GAME_DETAILS_BASE = `/:brand/game-details`;

export const APP_URLS = {
  home: '/',
  registration: '/registration',
  login: '/login',
  help: 'https://help.betzone.co.uk',
  virtualGames: {
    home: '/virtual-games',
  },
  myAccount: {
    home: '/my-account',
    profile: '/my-account/profile',
    activity: '/my-account/activity',
    settings: '/my-account/settings',
    gamblingControls: '/my-account/gambling-controls',
    bonusHistory: '/bonus-history',
  },
  gameDetailsBase: GAME_DETAILS_BASE,
  gameDetails: `${GAME_DETAILS_BASE}/:name/*`,
  promotionsRoot: '/promotions',
  promotions: '/promotions/:id?/:subId?',
  contentPage: '/pages/:slug',
  gam: '/gam/:slug',
  gameLobby: {
    main: '/game-lobby',
    dynamicPage: '/game-lobby/:category/:subcategory?',
  },
  privacyPolicy: '/pages/privacy-policy',
  cookiePolicy: '/pages/cookie-policy',
  terms: '#terms',

  itv: {
    root: '/',
    promotionRoot: '/promotion',
    promotion: '/promotion/:id?/:subId?',
    prizes: `/${BRANDS.PRIZES}`,
    prizesSubPages: `/${BRANDS.PRIZES}/:subpage`,

    spins: `/${BRANDS.SPINS}`,
    spinsSubPages: `/${BRANDS.SPINS}/:subpage`,

    bingo: `/${BRANDS.BINGO}`,
    bingoSubPages: `/${BRANDS.BINGO}/:subpage`,
    collectionViewAll: `/:brand/:subpage/:collection`,
    gameDetailsBase: ITV_GAME_DETAILS_BASE,
    gameDetails: `${ITV_GAME_DETAILS_BASE}/:name/*`,
  },
};
